import { Button, Heading, useToast } from '@chakra-ui/react';
import React, { FC } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import PlaceForm from '../../components/places/PlaceForm';
import { CreatePlaceMutationVariables, useCreatePlaceMutation } from '../../graphql/places/generated/createPlaceMutation.generated';

const CreatePlace: FC = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [createPlace, { loading }] = useCreatePlaceMutation();

  const onSubmit = async (data: CreatePlaceMutationVariables) => {
    try {
      await createPlace({
        variables: data,
      });
      toast({
        title: 'Standort erstellt',
        description: 'der Standort wurde erstellt',
        status: 'success',
        isClosable: true,
        duration: 5000,
      });
      navigate('/places');
    } catch (e) {
      if (e instanceof Error) {
        toast({
          title: 'Es ist etwas schiefgelaufen',
          description: `Fehlermeldung: ${e.message}`,
          status: 'error',
          isClosable: true,
          duration: 5000,
        });
      }
    }
  };

  return (
    <Layout>
      <Heading>Standort erstellen</Heading>
      <Button
        as={Link}
        to="/places"
        mt="4"
        leftIcon={<AiOutlineLeft />}
      >
        Zurück
      </Button>
      <PlaceForm
        loading={loading}
        withPublish
        onSubmit={onSubmit}
      />
    </Layout>
  );
};

export default CreatePlace;
